import './index.css';

import '@myosh/odin-translations/i18n';
import { applyStoredColorScheme, mountColorSchemeStylesheet } from '@myosh/design-system/color-scheme';
import { AuthProvider, UserProvider } from '@myosh/myosh-login';
import { PrimeReactComponentProvider, Toaster, TooltipProvider } from '@myosh/odin-components';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';
import laraDark from 'primereact/resources/themes/lara-dark-blue/theme.css?inline';
import laraLight from 'primereact/resources/themes/lara-light-blue/theme.css?inline';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import { App } from '@/app';
import { store } from '@/redux/store';

mountColorSchemeStylesheet(laraLight, 'light', 'primereact.theme');
mountColorSchemeStylesheet(laraDark, 'dark', 'primereact.theme');
applyStoredColorScheme();

const root = document.getElementById('root');

if (root) {
  createRoot(root).render(
    <StrictMode>
      <Provider store={store}>
        <BrowserRouter basename={import.meta.env.BASE_URL}>
          <NuqsAdapter>
            <AuthProvider>
              <UserProvider>
                <PrimeReactComponentProvider>
                  <TooltipProvider>
                    <App />
                    <Toaster />
                  </TooltipProvider>
                </PrimeReactComponentProvider>
              </UserProvider>
            </AuthProvider>
          </NuqsAdapter>
        </BrowserRouter>
      </Provider>
    </StrictMode>
  );
}
